import React, { useState } from 'react';

// Confirmación para cancelar un pedido (9-oct-2026), dentro de la misma ficha.
// Reemplaza el cartel del navegador ("gestiondlt.com dice…") que quedaba feo.
// Admin: elige o escribe el motivo (le llega a la empresa). Empresa (22-oct-2026): también con motivo,
// que nos llega a nosotros y al técnico.
const MOTIVOS = ['No tenemos disponibilidad', 'Ya se resolvió', 'Pedido duplicado', 'Lo coordinamos por otro medio'];
const MOTIVOS_EMPRESA = ['El cliente ya no lo necesita', 'Era un error', 'Pedido duplicado'];

export default function CancelarPedido({ modo, onConfirmar, onVolver }) {
    const [motivo, setMotivo] = useState('');
    const [enviando, setEnviando] = useState(false);
    const esAdmin = modo === 'admin';
    const confirmar = async () => {
        setEnviando(true);
        try { await onConfirmar(motivo.trim()); }
        finally { setEnviando(false); }
    };
    return (
        <div className="p-3.5 rounded-2xl bg-[rgba(201,52,31,0.08)] space-y-2.5">
            <p className="text-body font-black text-ink">{esAdmin ? '¿Por qué se cancela?' : '¿Por qué lo cancelás?'}</p>
            <p className="text-caption text-secondary">{esAdmin ? 'Le llega a la empresa en la conversación del pedido.' : 'Le avisamos a Dispenser La Tienda y al técnico que ya no hace falta.'}</p>
            <div className="flex flex-wrap gap-1.5">
                {(esAdmin ? MOTIVOS : MOTIVOS_EMPRESA).map(m => (
                    <button key={m} type="button" onClick={() => setMotivo(m)}
                        className={`h-8 px-3 rounded-full text-caption font-black active:scale-95 ${motivo === m ? 'bg-[#C9341F] text-white' : 'bg-chip text-secondary'}`}>{m}</button>
                ))}
            </div>
            <textarea rows={2} value={motivo} onChange={e => setMotivo(e.target.value)} maxLength={esAdmin ? 500 : 200} autoFocus
                placeholder={esAdmin ? 'O escribilo con tus palabras…' : 'Otro motivo…'}
                className="w-full px-3.5 py-2.5 rounded-xl bg-chip text-body text-ink outline-none resize-none placeholder:text-muted" />
            <div className="flex gap-2">
                <button type="button" onClick={onVolver} disabled={enviando}
                    className="flex-1 h-11 rounded-xl bg-chip text-secondary text-label font-black active:scale-95">Volver</button>
                <button type="button" onClick={confirmar} disabled={enviando || !motivo.trim()}
                    className="flex-[2] h-11 rounded-xl bg-[#C9341F] text-white text-label font-black active:scale-95 disabled:opacity-50">
                    {enviando ? 'Cancelando…' : 'Sí, cancelar pedido'}
                </button>
            </div>
        </div>
    );
}
